import { DevicesRouterStoreSelectors } from '@era/stores';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { selectAllDeviceAssignmentHistory } from './device-assignment-history.reducer';
import { DeviceAssignmentHistoryState } from './device-assignment-history.state';

export const selectDeviceAssignmentHistoryState =
  createFeatureSelector<DeviceAssignmentHistoryState>('device-assignment-history');

export const selectDeviceAssignmentHistory = createSelector(
  selectDeviceAssignmentHistoryState,
  selectAllDeviceAssignmentHistory
);

export const selectDeviceAssignmentHistoryForCurrentUdid = createSelector(
  selectDeviceAssignmentHistoryState,
  DevicesRouterStoreSelectors.selectUdid,
  (history, udid: string) => [...(history.entities[udid]?.history ?? [])]
);
